import * as React from "react";
import {modelSet, RenderEngine} from "../../../Controller/3DController/RenderEngine";
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css';
import { ARCannotActivateError, ARController } from "../../../Controller/ARController/ARController";
import { SelectionController } from "../../../Controller/3DController/SelectionController";
import {HotspotController} from "../../../Controller/3DController/HotspotController";
import {Controller3D} from "../../../Controller/3DController/3DController";
import {ConfiguratorModel, SelectionGroup} from "../../../Controller/3DController/ConfiguratorModel";
import {Transition, TransitionGroup, CSSTransition} from "react-transition-group"
import MediaQuery, { useMediaQuery } from 'react-responsive';
import { CarModelCameraList } from "../../../Controller/3DController/ModelLoad/ModelLoadController";
import {landing} from "../../App";
import {translate} from "../../../Controller/3DController/translateController";
import {DeviceOrientationCameraController} from "../../../Controller/3DController/DeviceOrientationCameraController";
import {MenuMobile} from "../MenuMobile/MenuMobile";
import {Menu} from "../Menu/Menu";
import {isMobile} from "react-device-detect";
import {WebShareController} from "../../../Controller/3DController/WebShareController";
import {trackARLoad, trackInfoClick} from "../../../Controller/Tracking";
import CarPlacementOverlay from '../CarPlacementOverlay';
import { XREngine, XRInitialScale, XRStatus } from "../../../Controller/ARController/XREngine";
import { SequenceController } from '../../../Controller/3DController/SequenceController';
import { AudioController } from '../../../Controller/3DController/AudioController';
import MenuDesktop from '../MenuDesktop/MenuDesktop';
import { Responsive } from '../MediaQueries';

interface Props{
    engine:RenderEngine,
    selectionController:SelectionController,
    deviceOrientationCameraController:DeviceOrientationCameraController,
    arController:ARController,
    controller3D: Controller3D,
    hotSpotController: HotspotController,
    modelController: ConfiguratorModel,
    toggleMenu:()=>void,
    presentation:()=>void,
    appendHotspot:()=>void,
    highlightAR:boolean,
    ARQR:()=>void,
    warning:boolean,
    mediaQueryIpad:boolean,
    drive:()=>void,
    hideMenu:boolean,
    screenshotMode:()=>void,
    shareService:WebShareController,
    switchingModel:()=>void,
    trunkLoadingMode:()=>void,
    genericPassengerMode:()=>void,
    xRayMode:()=>void,
    exporting:boolean,
    onEnterAR:()=>void,
    onLeaveAR:()=>void,
    sequenceController: SequenceController,
    sequenceMode: () => void,
    audioController: AudioController,
}

interface State{
    menuActive:boolean;
    menuActiveAnimation:boolean;
    currentMenu:SelectionGroup,
    currentSelection:SelectionGroup,
    lightOn:boolean,
    doorOpen:boolean,
    hotSpot:boolean,
    gyroEnabled:boolean,
    currentHighlight:number,
    interior:boolean,
    currentScroll:number,
    intensity:number,
    airbag:boolean,
    sharing:boolean,
    menuConfig:boolean,
    menuInteraction:boolean,
    modelName:string,
    modelLine:string,
    xrStatus:XRStatus,
    xrInitialScale:XRInitialScale
}

export class MenuMain extends React.Component<Props,State> {
    constructor(props:Props){
        super(props);
        this.state={
            menuActiveAnimation:false,
            menuActive:false,
            currentMenu:null,
            currentSelection:null,
            lightOn:false,
            doorOpen:false,
            hotSpot:false,
            currentHighlight:0,
            interior:false,
            currentScroll:0,
            gyroEnabled:false,
            intensity:0,
            airbag:false,
            sharing:false,
            menuConfig:false,
            menuInteraction:false,
            modelName:"",
            modelLine:"",
            xrStatus: XRStatus.Stopped,
            xrInitialScale: XRInitialScale.RealWorld
        };
        this.props.selectionController.setCloseMenuCallback(()=>{
            this.props.controller3D.exitWheel();
            this.turnOffHotSpot();
            this.setState({
                menuActive:false,
                menuActiveAnimation:false,
                currentMenu:null
            })
        })
    }

    private obsModel = ()=>{
        if(!this.props.modelController){
            return;
        }
        this.setState({
            lightOn:this.props.modelController.isLightOn(),
            doorOpen:this.props.controller3D.carOpen,
            airbag:this.props.controller3D.airbagOpen,
            currentSelection:this.props.modelController.getSelection("Car paint"),
            intensity:this.props.modelController.getAmbilightIntensity()*255,
            modelName:this.props.modelController.modelLoadController.getCurrentModelGroup().name,
            modelLine:this.props.modelController.modelLoadController.getModel().line
        })
        if(this.state.currentMenu){
            let name = this.state.currentMenu.name;
            this.setState({
                currentMenu:this.props.modelController.getSelection(name),
                currentHighlight: this.props.modelController.getSelectionActive(name)
            })
        }
    }

    private obs3D = ()=>{
        if(this.props.controller3D){
            this.setState({
                doorOpen:this.props.controller3D.carOpen,
                airbag:this.props.controller3D.airbagOpen
            })
        }
    }

    private obsInteriorExterior = ()=>{
        if(this.props.controller3D){
            this.setState({
                interior: this.props.controller3D.isInterior()
            })
        }
    }

    private obsInterior = () => {
        // Removed due to New UI
        // this.setState({
        //     currentMenu: null
        // });
    }

    private obsXR = (status:XRStatus) => {
        this.setState({
            xrStatus: status
        });
    }

    componentDidMount(){
        ConfiguratorModel.event.on('selection', this.obsModel)

        ConfiguratorModel.event.on('interior', this.obsInterior)

        Controller3D.event.on('animation', this.obs3D)

        Controller3D.event.on(Controller3D.EVENT_INTERIOR_EXTERIOR, this.obsInteriorExterior)

        ConfiguratorModel.event.on('RESET', ()=>{
            this.obsModel()
        })

        HotspotController.event.on('hotspot', ()=>{
            if(this.props.hotSpotController){
                this.setState({
                    hotSpot:this.props.hotSpotController.visible
                })
            }
        })

        if(this.props.hotSpotController){
            this.setState({
                hotSpot:this.props.hotSpotController.visible
            })
        }
        if(this.props.modelController){
            this.setState({
                lightOn:this.props.modelController.isLightOn(),
                intensity:this.props.modelController.getAmbilightIntensity()*255,
                modelName:this.props.modelController.modelLoadController.getCurrentModelGroup().name,
                modelLine:this.props.modelController.modelLoadController.getModel().line
            })

        }
        if(this.props.controller3D){
            this.setState({
                doorOpen:this.props.controller3D.carOpen,
                airbag:this.props.controller3D.airbagOpen
            })
        }
        DeviceOrientationCameraController.event.on(DeviceOrientationCameraController.ENABLE_CHANGE, () => {
            this.setState({
                gyroEnabled: this.props.deviceOrientationCameraController.enabled
            })
        })

        this.props.arController.xrEngine.event.on(XREngine.EVENT_STATUS_CHANGE, this.obsXR);
    }

    componentWillUnmount(){
        ConfiguratorModel.event.off('selection', this.obsModel)

        ConfiguratorModel.event.off('interior', this.obsInterior)

        Controller3D.event.off('animation', this.obs3D)

        Controller3D.event.off(Controller3D.EVENT_INTERIOR_EXTERIOR, this.obsInteriorExterior)

        this.props.arController.xrEngine.event.off(XREngine.EVENT_STATUS_CHANGE, this.obsXR);
    }

    toogleMenu(){
        let b = !this.state.menuActive;
        if(!b){
            this.props.controller3D.exitWheel();
            this.setState({menuActiveAnimation:false, currentMenu:null})
        }
        else{
            this.setState({menuActive:b, menuActiveAnimation:true})
        }
    }

    changeMenu(config:boolean){
        this.setState({
            currentMenu:null
        });
        if(this.props.controller3D && this.props.controller3D.airbagOpen){
            this.props.controller3D.playAirbagsAnimation();
        }
        if(config){
            let b = !this.state.menuConfig;
            if(!b){
                this.props.controller3D.exitWheel();
                this.setState({
                    menuActiveAnimation:false, currentMenu:null
                },()=>{
                        setTimeout(()=>{
                            this.props.controller3D.exitWheel(); this.setState({menuConfig:b, currentMenu:null})
                        }, 750)
                })
            }
            else{
                this.setState({menuInteraction:false, menuActiveAnimation:false},()=>{
                    this.setState({menuConfig:b, menuActiveAnimation:true})
                })
            }
        }
        else{
            let b = !this.state.menuInteraction;
            
            /* This line of code was inside the '!b'-condition before,
             * but it has to always run, so that we leave the wheel camera
             * when switching from configuration to interaction menu.
             * I'm not sure if this change has any other implications.
             */
            this.props.controller3D.exitWheel();
            
            if(!b){
                this.setState({
                    menuActiveAnimation:false, currentMenu:null
                },()=>{
                    setTimeout(()=>{
                        this.props.controller3D.exitWheel(); this.setState({menuInteraction:b, currentMenu:null})
                    }, 750)
                })
            }
            else{
                this.setState({menuConfig:false, menuActiveAnimation:false},()=>{
                    this.setState({menuInteraction:b, menuActiveAnimation:true})
                })
            }
        }
    }

    turnOffHotSpot(){
        if(this.state.hotSpot){
            this.toggleHotSpot()
        }
    }

    toggleHotSpot(){
        this.props.hotSpotController.toggleHotspots();
        this.setState({
            hotSpot: this.props.hotSpotController.visible
        })
        if(this.props.hotSpotController.visible){
            trackInfoClick();
        }
    }

    toogleInterior() {
        if(this.props.controller3D && this.props.controller3D.airbagOpen){
            this.props.controller3D.playAirbagsAnimation();
        }
        this.props.modelController.setInterior(!this.props.controller3D.isInterior());
        this.setState({currentScroll:0})
    }

    checkMenuActive(name):boolean{
        return(this.state.currentMenu && (this.state.currentMenu.name.toLowerCase() === name.toLowerCase()))
    }

    turnOnSubMenu(name:string){
        if(this.props.controller3D && this.props.controller3D.airbagOpen){
            this.props.controller3D.playAirbagsAnimation();
        }
        this.turnOffHotSpot();
        if(!name){
            this.setState({
                currentMenu: null,
                currentHighlight: 0
            })
            return;
        }
        if(this.state.currentMenu && this.state.currentMenu.name.toLowerCase() === name.toLowerCase()){
            this.setState({
                currentMenu: null,
                currentHighlight: 0
            })
            this.props.controller3D.exitWheel();
            return;
        }
        this.setState({
            currentMenu: null
        },()=>{
            this.setState({
                currentMenu: this.props.modelController.getSelection(name),
                currentHighlight: this.props.modelController.getSelectionActive(name)
            })
            if(name === "Wheels"){
                this.props.controller3D.setCamera(CarModelCameraList.Wheel);
            }
            else{
                this.props.controller3D.exitWheel();
            }
        })

    }

    toogleShareSubMenu(){
        if(this.props.shareService.deviceCanShare()){
            this.props.shareService.share("Taos Title", "Taos Description", this.props.modelController.getConfigURL());
            this.setState({
                sharing:false
            })
            return;
        }
        let b = !this.state.sharing
        this.turnOffHotSpot();
        this.setState({
            currentMenu: null,
            currentHighlight: 0,
            sharing:b
        })
    }

    //===================================================

    //<MediaQuery minWidth={950} maxWidth={2560}>

    render(){
        
        if(this.props.hideMenu){
            return "";
        }

        const toggleActive = this.state.xrInitialScale == XRInitialScale.Table;
        const toggleOnChange = () => {
            let initialScale = this.state.xrInitialScale;

            if (initialScale == XRInitialScale.RealWorld) {
                initialScale = XRInitialScale.Table;
            } else {
                initialScale = XRInitialScale.RealWorld;
            }

            this.setState({xrInitialScale: initialScale});
            this.props.arController.xrEngine.initialScale = initialScale;
        };

        if (this.state.xrStatus == XRStatus.Scan) {
            return (
                <CarPlacementOverlay
                    type="scan"
                    text={translate("id_xr_scan")}
                    toggleActive={toggleActive}
                    toggleOnChange={toggleOnChange}
                />
            );
        } else if (this.state.xrStatus == XRStatus.Place) {
            return <CarPlacementOverlay
                type="place"
                text={translate("id_xr_place")}
                toggleActive={toggleActive}
                toggleOnChange={toggleOnChange}
            />;
        }

        return (
            <>
                <Responsive
                    desktop={(
                        <MenuDesktop
                            toggleMenu={this.toogleMenu.bind(this)}
                            presentation={this.props.presentation}
                            appendHotspot={this.props.appendHotspot}
                            ARQR={this.props.ARQR}
                            warning={this.props.warning}
                            menuActive={this.state.menuActive}
                            menuActiveAnimation={this.state.menuActiveAnimation}
                            interior={this.state.interior}
                            hotSpot={this.state.hotSpot}
                            toggleHotSpot={this.toggleHotSpot.bind(this)}
                            toogleInterior={this.toogleInterior.bind(this)}
                            checkMenuActive={this.checkMenuActive.bind(this)}
                            doorOpen={this.state.doorOpen}
                            turnOnSubMenu={this.turnOnSubMenu.bind(this)}
                            currentMenu={this.state.currentMenu}
                            lightOn={this.state.lightOn}
                            engine={this.props.engine}
                            controller3D={this.props.controller3D}
                            modelController={this.props.modelController}
                            closeMenu={()=>{let b = !this.state.menuActive; this.props.controller3D.exitWheel(); this.setState({menuActive:b, currentMenu:null})}}
                            highlightAR={this.props.highlightAR}
                            gyroEnabled={this.state.gyroEnabled}
                            exporting={this.props.exporting}
                            onEnterAR={this.props.onEnterAR}
                            onLeaveAR={this.props.onLeaveAR}
                            deviceOrientationCameraController={this.props.deviceOrientationCameraController}
                            mediaQueryIpad={this.props.mediaQueryIpad}
                            intensity={this.state.intensity}
                            drive={this.props.drive}
                            screenshotMode={this.props.screenshotMode}
                            airbag={this.state.airbag}
                            sharing={this.state.sharing}
                            toogleSharing={this.toogleShareSubMenu.bind(this)}
                            changeMenu={this.changeMenu.bind(this)}
                            menuInteraction={this.state.menuInteraction}
                            menuConfig={this.state.menuConfig}
                            switchingModel={this.props.switchingModel}
                            trunkLoadingMode={this.props.trunkLoadingMode}
                            genericPassengerMode={this.props.genericPassengerMode}
                            xRayMode={this.props.xRayMode}
                            modelName={this.state.modelName}
                            modelLine={this.state.modelLine}
                            xrActive={this.state.xrStatus != XRStatus.Stopped}
                            sequenceController={this.props.sequenceController}
                            sequenceMode={this.props.sequenceMode}
                            audioController={this.props.audioController}
                        />
                    )}
                    mobile={(
                        <MenuMobile
                            toggleMenu={this.toogleMenu.bind(this)}
                            presentation={this.props.presentation}
                            appendHotspot={this.props.appendHotspot}
                            ARQR={this.props.ARQR}
                            warning={this.props.warning}
                            menuActive={this.state.menuActive}
                            menuActiveAnimation={this.state.menuActiveAnimation}
                            interior={this.state.interior}
                            hotSpot={this.state.hotSpot}
                            toggleHotSpot={this.toggleHotSpot.bind(this)}
                            toogleInterior={this.toogleInterior.bind(this)}
                            checkMenuActive={this.checkMenuActive.bind(this)}
                            doorOpen={this.state.doorOpen}
                            turnOnSubMenu={this.turnOnSubMenu.bind(this)}
                            currentMenu={this.state.currentMenu}
                            lightOn={this.state.lightOn}
                            engine={this.props.engine}
                            controller3D={this.props.controller3D}
                            modelController={this.props.modelController}
                            closeMenu={()=>{let b = !this.state.menuActive; this.props.controller3D.exitWheel(); this.setState({menuActive:b, currentMenu:null})}}
                            highlightAR={this.props.highlightAR}
                            gyroEnabled={this.state.gyroEnabled}
                            exporting={this.props.exporting}
                            onEnterAR={this.props.onEnterAR}
                            onLeaveAR={this.props.onLeaveAR}
                            deviceOrientationCameraController={this.props.deviceOrientationCameraController}
                            mediaQueryIpad={this.props.mediaQueryIpad}
                            intensity={this.state.intensity}
                            drive={this.props.drive}
                            screenshotMode={this.props.screenshotMode}
                            airbag={this.state.airbag}
                            sharing={this.state.sharing}
                            toogleSharing={this.toogleShareSubMenu.bind(this)}
                            changeMenu={this.changeMenu.bind(this)}
                            menuInteraction={this.state.menuInteraction}
                            menuConfig={this.state.menuConfig}
                            switchingModel={this.props.switchingModel}
                            trunkLoadingMode={this.props.trunkLoadingMode}
                            genericPassengerMode={this.props.genericPassengerMode}
                            xRayMode={this.props.xRayMode}
                            modelName={this.state.modelName}
                            modelLine={this.state.modelLine}
                            xrActive={this.state.xrStatus != XRStatus.Stopped}
                            sequenceController={this.props.sequenceController}
                            sequenceMode={this.props.sequenceMode}
                            audioController={this.props.audioController}
                        />
                    )}
                />
            </>
        );
    }
}


